import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./app.component').then((m) => m.AppComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./screens/landing/landing.component').then(
            (m) => m.LandingComponent,
          ),
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./screens/home/home.component').then((m) => m.HomeComponent),
      },
    ],
  },
];
